// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1dvI8{animation:b268o 1.25s linear infinite}@keyframes b268o{0%{opacity:1}65%{opacity:1}66%{opacity:0}to{opacity:0}}.J7tZ7{animation:Exr7x 1.25s linear infinite}@keyframes Exr7x{0%{opacity:0}21%{opacity:0}22%{opacity:1}65%{opacity:1}66%{opacity:0}to{opacity:0}}.hbO7e{animation:QWIdF 1.25s linear infinite}@keyframes QWIdF{0%{opacity:0}43%{opacity:0}44%{opacity:1}65%{opacity:1}66%{opacity:0}to{opacity:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dot1": "_1dvI8",
	"dot1-animation": "b268o",
	"dot2": "J7tZ7",
	"dot2-animation": "Exr7x",
	"dot3": "hbO7e",
	"dot3-animation": "QWIdF"
};
module.exports = ___CSS_LOADER_EXPORT___;
